import { useState, useEffect } from "react";
import { SectionAccordion, CashRow, RateWorkRow } from "./TransactionAccordian";
import ModalWrapper from "./ModalWrapper";
import { transformSectionsIntoUI } from "../../utils/sections";

export default function TransactionAccordionModal({ viewTx, onClose }) {
  const [tx, setTx] = useState({});

  useEffect(() => {
    const raw = viewTx?.tx?.[viewTx.type];
    setTx(transformSectionsIntoUI(raw));
  }, [viewTx]);

  return (
    <ModalWrapper
      show={!!viewTx}
      onClose={onClose}
      title="Show Transactions"
      size="lg"
    >
      <div className="section-sp">
        <CashRow amount={tx.cash?.amount} />

        {["pc", "lab", "bar", "coin", "ginni", "silver"].map((key) => (
          <SectionAccordion
            key={key}
            label={key.toUpperCase()}
            sectionKey={key}
            transactions={tx[key]?.transactions}
            paidAmounts={tx[key]?.paidAmounts}
          />
        ))}

        <RateWorkRow label="Gold - Rate of Work" rw={tx.goldRW} />
        <RateWorkRow label="Silver - Rate of Work" rw={tx.silverRW} />
      </div>
    </ModalWrapper>
  );
}
